<template>
  <div id="shousai-content">
    <div
      id="shousai_inner"
      :style="`background: url(${userRealIntentionImageUrlForPc}/back.png; ${innerStyle}`"
    >
      <div
        id="shousai_width"
        class="mt10 ml5"
      >
        <div
          id="honne_box"
          class="honne_box preview-clearfix"
        >
          <div class="data_box fll tc">
            <img
              :src="`${userRealIntentionIconImageUrlForPc}`"
              data-test="icon-url"
            >
            <div class="profile tl">
              <div class="profile_inner fs13">
                <p class="mb15">
                  回答日 <span data-test="answer-date">{{ realIntention.createDate | formatDate }}</span>
                </p>
                <p>
                  <span data-test="content">{{ content }}</span>
                </p>
              </div>
            </div>
          </div>
          <div class="arrow_box fll">
            <ul
              id="question"
              :style="`background: url(${userRealIntentionImageUrlForPc}/q.png) no-repeat 35px 28px;`"
            >
              <li
                class="fs14"
                data-test="question1"
              >
                1．あなたの会社はどんな会社だと思う？
              </li>
              <li
                class="fs14"
                data-test="question2"
              >
                2．会社の一番良いところは？
              </li>
              <li
                class="fs14"
                data-test="question3"
              >
                3．会社に期待していることは？
              </li>
            </ul>
            <ul
              id="answer"
              class="preview-clearfix pega-pre-wrap"
            >
              <li class="fs15">
                <span>1．</span>
                <p
                  data-test="answer1"
                  v-text="realIntention.question1"
                />
              </li>
              <li class="fs15">
                <span>2．</span>
                <p
                  data-test="answer2"
                  v-text="realIntention.question2"
                />
              </li>
              <li class="fs15">
                <span>3．</span>
                <p
                  data-test="answer3"
                  v-text="realIntention.question3"
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/pc/realintention/_base" as *;
</style>

<script>
import dayjs from 'dayjs'
import _ from 'lodash'
import { realIntentionRegister } from '@/lib/labelValueMappings'

const USER_URL = process.env.USER_ENDPOINT

export default {
  filters: {
    formatDate (val) {
      return val ? dayjs(val).format('YYYY.M') : ''
    }
  },
  props: {
    realIntention: {
      type: Object,
      required: true
    },
    innerStyle: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      iconNames: realIntentionRegister.iconNames
    }
  },
  computed: {
    userRealIntentionImageUrlForPc: () => `${USER_URL}/th/pc/img/realintention`,
    userRealIntentionIconImageUrlForPc () {
      if (!_.isEmpty(this.realIntention) && _.includes(this.iconNames, this.realIntention.icon)) {
        return `${this.userRealIntentionImageUrlForPc}/${this.realIntention.icon}`
      }
      return ''
    },
    content () {
      if (_.isEmpty(this.realIntention)) return
      return [
        `${this.realIntention.post}`,
        this.realIntention.gender.name ? this.realIntention.gender.name : '',
        this.realIntention.age ? `${this.realIntention.age}歳` : '',
        this.realIntention.serviceYear ? `${this.realIntention.serviceYear}年目` : ''
      ].filter(v => v).join(' / ').concat(this.realIntention.career.name ? ` (${this.realIntention.career.name}入社)` : '')
    }
  }
}
</script>
